<div class="min-h-screen bg-gray-50 flex flex-col">

  <!-- Header -->
  <header class="bg-white border-b border-gray-100 shadow-sm">
    <div class="max-w-5xl mx-auto px-4 py-4 flex items-center gap-3">
      <img src="assets/images/logo-couleur_1@4x.png" alt="Agodjie" class="h-10 w-auto">
      <div class="ml-auto">
        <span class="px-3 py-1.5 rounded-full bg-ag-red/10 text-ag-red text-sm font-semibold">Recrutement</span>
      </div>
    </div>
  </header>

  <!-- Hero -->
  <section class="bg-white">
    <div class="max-w-5xl mx-auto px-4 py-10 text-center">
      <h1 class="text-3xl font-bold text-gray-900 m-0">Rejoignez notre équipe</h1>
      <p class="text-gray-500 mt-2 mb-0">Découvrez nos offres d'emploi et postulez en ligne en quelques minutes.</p>
    </div>
  </section>

  <!-- Offres -->
  <main class="flex-1">
    <div class="max-w-5xl mx-auto px-4 py-8">
      <app-loading [isVisible]="loading"></app-loading>

      @if (error) {
        <p class="text-center text-ag-red py-12">Une erreur est survenue lors du chargement des offres.</p>
      }

      @if (!loading && !error && offers.length === 0) {
        <p class="text-center text-gray-400 py-12">Aucune offre disponible pour le moment.</p>
      }

      <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
        @for (o of offers; track o.id) {
          <a [routerLink]="['/recrutement', o.id]"
             class="block rounded-2xl border border-gray-100 bg-white p-5 shadow-sm hover:shadow-md hover:border-ag-red/40 transition-all">
            <div class="flex items-start justify-between gap-3">
              <h2 class="text-lg font-bold text-gray-900 m-0">{{o.title}}</h2>
              @if (o.contract_type) {
                <span class="shrink-0 px-2.5 py-0.5 rounded-full bg-ag-red/10 text-ag-red text-xs font-semibold">{{o.contract_type}}</span>
              }
            </div>
            <div class="flex flex-wrap items-center gap-2 mt-2 text-xs text-gray-500">
              @if (o.category) { <span class="px-2 py-0.5 rounded-full bg-gray-100">{{o.category}}</span> }
              @if (o.location) { <span>📍 {{o.location}}</span> }
              @if (o.positions) { <span>{{o.positions}} poste(s)</span> }
            </div>
            <p class="text-sm text-gray-600 mt-3 mb-0 line-clamp-3">{{o.description}}</p>
            <div class="flex items-center justify-between mt-4">
              @if (o.deadline) {
                <span class="text-xs text-gray-400">Limite : {{o.deadline | date:'dd/MM/yyyy'}}</span>
              } @else { <span></span> }
              <span class="text-sm font-semibold text-ag-red">Voir l'offre →</span>
            </div>
          </a>
        }
      </div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="bg-white border-t border-gray-100">
    <div class="max-w-5xl mx-auto px-4 py-6 text-center text-xs text-gray-400">
      © {{ 2025 }} Agodjie — Tous droits réservés.
    </div>
  </footer>
</div>
